// src/pages/BookDemo.jsx
import React from 'react';
import BookDemoForm from '../components/BookDemoForm';

const BookDemo = () => {
  return (
    <div className="min-h-screen bg-gray-100 pt-20">
      <BookDemoForm />
    </div>
  );
};

export default BookDemo;
